import Vue from "vue";
import hasAccessRightMixin from "@/mixins/hasAccessRight";

Vue.mixin(hasAccessRightMixin);
